export default {
  baseStyle: {
    text: { color: 'white', fontSize: '1rem', fontFamily: 'medium' },
  },
};
